(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/my-orders/components/order-table-row.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/my-orders/components/order-table-row.js');
"use strict";

const {
  TableRow,
  TableCell
} = svs.ui.reactTable;
const OrderTableRow = _ref => {
  let {
    productName,
    numberOfVouchers,
    lastValid,
    singleVoucherValue
  } = _ref;
  const sum = singleVoucherValue * numberOfVouchers;
  const lastValidDate = lastValid && svs.utils.date.SimpleDate(new Date(lastValid));
  return React.createElement(TableRow, null, React.createElement(TableCell, null, productName), React.createElement(TableCell, null, numberOfVouchers), React.createElement(TableCell, null, lastValidDate), React.createElement(TableCell, null, sum));
};
svs.ticket_partner.myOrders.components.OrderTableRow = OrderTableRow;

 })(window);